import { useNavigate, useLocation } from "react-router-dom";
import { Plus, SkipForward } from "lucide-react";
import infoIcon from "../design-icons/info.svg";

const BASE = "#A1A1AA";

function getInitials(name) {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const PAGE_TITLES = {
  "/Hire360/Dashboard": "Job Management Dashboard",
  "/Hire360/launch-attract": "Requisitions",
  "/Hire360/screen-select": "Candidate Pipeline",
  "/Hire360/decide-offer": "Offers",
  "/Hire360/verify-comply": "Compliance",
  "/Hire360/welcome-transition": "Journey",
  "/Hire360/time-keeper": "myTE",
  "/Hire360/skip-line": "Fast Track",
  "/Hire360/insights": "Insights",
};

const Header = ({ userName = "User" }) => {
  const navigate = useNavigate();
  const location = useLocation()

  const pageTitle = PAGE_TITLES[location.pathname] || "Job Management Dashboard";

  return (
    <header className="sticky top-0 z-50 bg-white">
      <div className="flex items-center justify-between px-6 py-2 gap-4">

        {/* Left: Page title + info icon */}
        <div className="flex items-center gap-2">
          <h1 className="text-lg font-bold text-slate-800 tracking-tight">
            {pageTitle}
          </h1>
          {/* <img src={infoIcon} alt="info icon" className="w-5 h-5 text-zinc-400" /> */}
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-3 flex-shrink-0">
          {/* <button
            type="button"
            onClick={() => navigate("/Hire360/launch-attract")}
            className="flex items-center gap-1.5 text-sm font-medium px-4 py-2 rounded-lg border border-none text-slate-900 transition bg-[#e9fffa] hover:bg-[#d1faf4] "
          >
            <Plus size={13} /> Create a New Job
          </button>
          <button
            type="button"
            onClick={() => navigate("/Hire360/skip-line")}
            className="flex items-center gap-1.5 text-sm font-medium px-4 py-2 rounded-lg border border-none text-slate-900 transition bg-gray-50 hover:bg-gray-100 "
          >
            <SkipForward size={13} /> Skip the Line
          </button> */}

          {/* Avatar + Name */}
          <div className="flex items-center gap-2 pl-2">
            <div
              className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
              style={{ background: BASE }}
            >
              {getInitials(userName)}
            </div>
            <span className="text-sm font-medium text-slate-700 hidden md:block">
              {userName}
            </span>
          </div>
        </div>

      </div>

      {/* Bottom gradient line */}
      <div className="w-full h-0 border-b-[1.5px] border-gray-200 shadow-sm" />
    </header>
  );
};

export default Header;